import { render, staticRenderFns } from "./not_found.vue?vue&type=template&id=d613fe6c&"
import script from "./not_found.vue?vue&type=script&lang=js&"
export * from "./not_found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports